import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { register } from '../services/api';

function RegisterPage() {
  const [email, setEmail]             = useState('');
  const [password, setPassword]       = useState('');
  const [confirm, setConfirm]         = useState('');
  const [showPw, setShowPw]           = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError]             = useState('');
  const [success, setSuccess]         = useState('');
  const [loading, setLoading]         = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 8)  { setError('Password must be at least 8 characters.'); return; }

    setLoading(true);
    try {
      await register({ email, password });
      setSuccess('Account created! Check your email to confirm your address before signing in.');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="a-auth-page">
      <div className="a-auth-card">
        <div className="a-auth-header">
          <img src="/uploads/scala-logo.png" alt="SCALA" className="a-auth-header__logo" />
          <div className="a-auth-header__title">SCALA Performer Registry</div>
          <div className="a-auth-header__subtitle">Celebrating Songwriting</div>
        </div>
        <div className="a-auth-body">
          <h2>Create Account</h2>

          {error   && <div className="a-error">{error}</div>}
          {success && <div className="a-success">{success}</div>}

          {!success && (
            <form onSubmit={handleSubmit}>
              <div className="a-field">
                <label className="a-label">Email Address</label>
                <input className="a-input" type="email" value={email}
                  onChange={e => setEmail(e.target.value)} required autoFocus />
              </div>
              <div className="a-field">
                <label className="a-label">Password</label>
                <div className="a-pw-wrap">
                  <input className="a-input" type={showPw ? 'text' : 'password'} value={password}
                    onChange={e => setPassword(e.target.value)} required placeholder="At least 8 characters" />
                  <button type="button" className="a-pw-toggle" onClick={() => setShowPw(v => !v)}>
                    {showPw ? 'Hide' : 'Show'}
                  </button>
                </div>
              </div>
              <div className="a-field">
                <label className="a-label">Confirm Password</label>
                <div className="a-pw-wrap">
                  <input className="a-input" type={showConfirm ? 'text' : 'password'} value={confirm}
                    onChange={e => setConfirm(e.target.value)} required />
                  <button type="button" className="a-pw-toggle" onClick={() => setShowConfirm(v => !v)}>
                    {showConfirm ? 'Hide' : 'Show'}
                  </button>
                </div>
              </div>
              <button type="submit" className="a-btn a-btn--navy a-btn--full" disabled={loading}
                style={{ marginTop: '0.5rem' }}>
                {loading ? 'Creating account…' : 'Create Account'}
              </button>
            </form>
          )}

          <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.875rem', color: '#6b7280' }}>
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
